import React, { useState, useEffect } from "react";
import axios from "axios";
import { Paper } from "@mui/material";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { Navbar } from "./Navbar";
import '../../css/SearchPage.css';
import '../../css/PropertyList.css'
import PropertyList from "./PropertyList";

const SearchPage = () => {
  const [properties, setProperties] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;
  const location = useLocation(); 
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    pincode: "",
    locality: "",
    propertyType: "",
    listingType: "",
    proptypename: "",
    bhk: "",
    furnishingType: "",
    sqRange: "",
    availableFrom: "",
    residentialPrice: "",
    commercialPrice: ""
  });

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const newFilters = Object.fromEntries(searchParams.entries());
    setFilters((prev) => ({ ...prev, ...newFilters }));
    fetchProperties(1, newFilters);
  }, [searchParams.toString()]);

  const fetchProperties = async (page, appliedFilters = {}) => {
    try {
      const response = await axios.get("/api/search", {
        params: { ...appliedFilters, page, limit },
      });

      setProperties((prev) =>
        page === 1 ? response.data.properties : [...prev, ...response.data.properties]
      );
      setTotalPages(response.data.totalPages);
      setCurrentPage(page);
    } catch (error) {
      console.error("❌ Error fetching search results:", error);
    }
  };

  const handleSearch = () => {
    const filteredParams = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== "")
    );
    navigate({
      pathname: "/search",
      search: new URLSearchParams(filteredParams).toString(),
    });
  };

  const loadMore = () => {
    if (currentPage < totalPages) {
      fetchProperties(currentPage + 1, filters);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="container1">
        <div className="filterContainer">
          {/* Updated filter layout */}
          <input
            type="text"
            placeholder="Pincode"
            value={filters.pincode}
            onChange={(e) => setFilters({ ...filters, pincode: e.target.value })}
          />
          <select
            value={filters.propertyType}
            onChange={(e) => setFilters({ ...filters, propertyType: e.target.value })}
          >
            <option value="">Select Property Type</option>
            <option value="Residential">Residential</option>
            <option value="Commercial">Commercial</option>
          </select>
          <select
            value={filters.listingType}
            onChange={(e) => setFilters({ ...filters, listingType: e.target.value })}
          >
            <option value="">Select Listing Type</option>
            <option value="Rent">Rent</option>
            <option value="Resale">Resale</option>
            {filters.propertyType === "Residential" && <option value="PG/Co-living">PG / Co-Living</option>}
          </select>

          {filters.propertyType === "Residential" && (
            <>
              <select
                value={filters.bhk}
                onChange={(e) => setFilters({ ...filters, bhk: e.target.value })}
              >
                <option value="">Select BHK</option>
                <option value="1 BHK">1 BHK</option>
                <option value="2 BHK">2 BHK</option>
                <option value="3 BHK">3 BHK</option>
              </select>
              <select
                value={filters.furnishingType}
                onChange={(e) => setFilters({ ...filters, furnishingType: e.target.value })}
              >
                <option value="">Select Furnishing</option>
                <option value="Fully Furnished">Fully Furnished</option>
                <option value="Semi Furnished">Semi Furnished</option>
                <option value="Unfurnished">Unfurnished</option>
              </select>
              <select
                value={filters.residentialPrice}
                onChange={(e) => setFilters({ ...filters, residentialPrice: e.target.value })}
              >
                <option value="">Select Price Range</option>
                <option value="0-25000">0 - 25K</option>
                <option value="25000-50000">25K - 50K</option>
                <option value="50000-75000">50K - 75K</option>
                <option value="75000-100000">75K - 1L+</option>
              </select>
            </>
          )}

          {filters.propertyType === "Commercial" && (
            <>
              <select
                value={filters.sqRange}
                onChange={(e) => setFilters({ ...filters, sqRange: e.target.value })}
              >
                <option value="">Select Sq. Ft Range</option>
                <option value="0-1000">0-1000 sqft</option>
                <option value="1000-2000">1000-2000 sqft</option>
                <option value="2000-5000">2000-5000 sqft</option>
              </select>
              <select
                value={filters.commercialPrice}
                onChange={(e) => setFilters({ ...filters, commercialPrice: e.target.value })}
              >
                <option value="">Select Price Range</option>
                <option value="0-40000">0 - 40K</option>
                <option value="40000-80000">40K - 80K</option>
                <option value="80000-120000">80K - 1.20L</option>
                <option value="120000-160000">1.20L - 1.60L</option>
                <option value="160000-200000">1.60L - 2.00L</option>
              </select>
            </>
          )}
          <input
            type="text"
            placeholder="Locality"
            value={filters.locality}
            onChange={(e) => setFilters({ ...filters, locality: e.target.value })}
          />
          <button onClick={handleSearch}>Search</button>
        </div>



<div className="property-list">
  {properties.length > 0 ? (
    properties.map((item, index) => (
      <Paper
        key={index}
        className="property-cards"
        onClick={() => navigate(`/property/${item.category}/${item.id}`)}
      >
        <div className="image-section">
          {item.image ? (
            <img
            src={item.image}
              alt={`Property ${item.id}`}
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "8px",
              }}
              className="property-image1"
            />
          ) : (
            <p className="noImage">No image available</p>
          )}
        </div>
        <div className="property-details">
         <h2>{item.bpn}</h2>
          <h3>{item.proptypename}</h3>
          <p className="price">Price: ₹{item.cost}</p>
          <p className="details">Area: {item.area} sqft</p>
          <hr />
          <p>Facing: {item.facing}, Location: {item.pinlocality}</p>
          <div className="agent-section">
            <div className="agent-icon">PP</div>
            <div>
              <p className="agent-name">Pincode Pillars Agent: Suresh</p>
              <p className="agent-role">Pincode Pillars Agent</p>
            </div>
          </div>
        </div>
        <button className="contact-btn">Contact</button>
      </Paper>
    ))
  ) : (
    <p>No properties found.</p>
  )}

  {currentPage < totalPages && (
    <div className="loadMore">
      <button onClick={loadMore}>Load More</button>
    </div>
  )}
</div>


    
      </div>
    </div>
  );
};

export default SearchPage;
